import React, { FC, ReactElement } from 'react'
import { CallRecIntegration } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import FormRow from '../../Common/Components/FormRow'
import Heading, { HeadingLevel } from '../../Common/Components/Heading'
import { ValidationErrors } from '../../Common/Components/ValidationErrors/ValidationErrors'
import {
    API_PARAMETERS_ONE_NAME,
    API_PARAMETERS_TWO_NAME,
    MAIN_AUTHENTICATION_DETAILS_PASSWORD_NAME,
    MAIN_AUTHENTICATION_DETAILS_USERNAME_NAME,
    MAIN_IP_ADDRESS_NAME,
    SECONDARY_AUTHENTICATION_DETAILS_PASSWORD_NAME,
    SECONDARY_AUTHENTICATION_DETAILS_USERNAME_NAME,
    SECONDARY_IP_ADDRESS_NAME
} from '../Constants/FieldNames'
import { OutlinedTextInput } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'

type Props = {
    viewOnly: boolean | undefined
}

export const CommunicationsSettings: FC<Props> = ({ viewOnly }: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(CallRecIntegration.NAME)

    return (
        <div className='user-details-tab tab-area'>
            <FormRow>
                <ValidationErrors name={MAIN_IP_ADDRESS_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsIPAddrOne)}
                        inputName={MAIN_IP_ADDRESS_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <ValidationErrors name={SECONDARY_IP_ADDRESS_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsIPAddrTwo)}
                        inputName={SECONDARY_IP_ADDRESS_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <Heading level={HeadingLevel.ONE}>Authentication Details (Main)</Heading>
            <FormRow>
                <ValidationErrors name={MAIN_AUTHENTICATION_DETAILS_USERNAME_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsAuthDetailsMainUserName)}
                        inputName={MAIN_AUTHENTICATION_DETAILS_USERNAME_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <ValidationErrors name={MAIN_AUTHENTICATION_DETAILS_PASSWORD_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsAuthDetailsMainUserPassword)}
                        inputName={MAIN_AUTHENTICATION_DETAILS_PASSWORD_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <Heading level={HeadingLevel.ONE}>Authentication Details (Secondary)</Heading>
            <FormRow>
                <ValidationErrors name={SECONDARY_AUTHENTICATION_DETAILS_USERNAME_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsAuthDetailsSecondaryUserName)}
                        inputName={SECONDARY_AUTHENTICATION_DETAILS_USERNAME_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <ValidationErrors name={SECONDARY_AUTHENTICATION_DETAILS_PASSWORD_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsAuthDetailsSecondaryUserPassword)}
                        inputName={SECONDARY_AUTHENTICATION_DETAILS_PASSWORD_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <Heading level={HeadingLevel.ONE}>PARAMETERS</Heading>
            <FormRow>
                <ValidationErrors name={API_PARAMETERS_ONE_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsApiParamOne)}
                        inputName={API_PARAMETERS_ONE_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <ValidationErrors name={API_PARAMETERS_TWO_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ApiComSettingsApiParamTwo)}
                        inputName={API_PARAMETERS_TWO_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
        </div>
    )
}
